import { gql } from '@provision/graphql-client';
import { RECORD_FOLDER_FRAGMENT } from './record-folder.fragments';

export const GET_RECORD_FOLDERS_QUERY = gql`
  query GetEnabledRecordFolders($partnerId: Int!, $area: String)
  @entity(name: "RecordFolder") {
    getEnabledRecordFolders(partnerId: $partnerId, area: $area) {
      records {
        ...RecordFolderFields
      }
    }
  }
  ${RECORD_FOLDER_FRAGMENT}
`;

export const CREATE_RECORD_FOLDERS_QUERY = gql`
  mutation CreateRecordFolder($data: RecordFolderDataInput) {
    createRecordFolder(data: $data) {
      ...RecordFolderFields
    }
  }
  ${RECORD_FOLDER_FRAGMENT}
`;

export const UPDATE_RECORD_FOLDERS_QUERY = gql`
  mutation UpdateRecordFolder($recordFolderId: String!, $data: RecordFolderDataInput) {
    updateRecordFolder(
      conditions: [{ attribute: "recordFolderId", operator: "=", value: $recordFolderId }]
      data: $data
    ) {
      ...RecordFolderFields
    }
  }
  ${RECORD_FOLDER_FRAGMENT}
`;

export const DELETE_RECORD_FOLDERS_QUERY = gql`
  mutation DeleteRecordFolderWithAssignments(
    $params: DeleteRecordFolderWithAssignmentsDataInput!
  ) {
    deleteRecordFolderWithAssignments(params: $params) {
      id
    }
  }
`;
